import { manageBehaviors } from '@area17/a17-behaviors';
import * as Behaviors from './behaviors'; // Critical behaviors
import 'what-input';
import 'wicg-inert';
import './bootstrap';
import './twill-image';
import lazyloading from './twill-image';

window.A17 = window.A17 || {};

import './stores/nav';

function setScrollbarWidth() {
  document.body.style.setProperty(
    '--scrollbar-width',
    window.innerWidth - document.body.clientWidth + 'px'
  );
}

document.addEventListener('DOMContentLoaded', () => {
  if ('Livewire' in window && typeof Livewire.on === 'function') {
    Livewire.hook('message.processed', (component) => {
      lazyloading.reset();

      // Fire a proxy event that we can more easily listen to
      document.dispatchEvent(new CustomEvent('livewire.message.processed'));
    });
  }
});

/**
 * Fixes Safari page caching case,
 * where if a user goes 'back' to a page
 */
window.addEventListener('pageshow', (evt) => {
  if (evt.persisted) {
    document.body.classList.remove('is-exiting');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  window.A17.behaviors = manageBehaviors;
  window.A17.behaviors.init(Behaviors, {
    breakpoints: ['xs', 'sm', 'md', 'lg', 'xl', 'xl2', 'xl3'],
  });

  // Expose scrollbar width to css
  setScrollbarWidth();
  window.addEventListener('resize', () => {
    setScrollbarWidth();
  });

  // Turn off prevent-transitions
  // const node = document.querySelector('.prevent-transitions');
  // if (node) {
  //   document.body.classList.remove('is-exiting');
  //   node.classList.remove('prevent-transitions');
  //   setTimeout(() => {
  //     node.classList.add('content-is-loaded');
  //     document.dispatchEvent(new CustomEvent('content-is-loaded'));
  //   }, 0);
  // }

  // document.addEventListener('click', function (evt) {
  //   const link =
  //     evt.target === 'a'
  //       ? evt.target
  //       : evt.target.closest('a')
  //       ? evt.target.closest('a')
  //       : null;
  //   if (link) {
  //     if (link.getAttribute('href')[0] !== '#' && link.target !== '_blank') {
  //       evt.preventDefault();
  //       document.body.classList.add('is-exiting');
  //       setTimeout(() => {
  //         window.location.href = link.href;
  //       }, 300);
  //     }
  //   }
  // });
});
